import { Theme, useMediaQuery } from '@mui/material';

export const useThemeBreakpoint = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.between('sm', 'lg'));
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  return { isMobile, isTablet, isDesktop };
};
